import { render, staticRenderFns } from "./processDialog.vue?vue&type=template&id=415cb672&scoped=true"
import script from "./processDialog.vue?vue&type=script&lang=js"
export * from "./processDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415cb672",
  null
  
)

export default component.exports